export const absoluteRoutesNames = {
	HOME: '/app/home',
	DASHBOARD: '/dashboard',
	LOGIN: '/auth/login',
	LOGOUT: '/auth/logout',
};
